var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { renderIcon } from '../../utils';
import { classNames } from '../../utils/style-class.utils';
import Typography from '../typography/typography';
import * as styles from './status-chip.styles';
export var StatusChip = function (_a) {
    var borderColour = _a.borderColour, textColour = _a.textColour, backgroundColour = _a.backgroundColour, text = _a.text, _b = _a.textType, textType = _b === void 0 ? 'buttonSmall' : _b, _c = _a.textWeight, textWeight = _c === void 0 ? 'bold' : _c, icon = _a.icon, iconPosition = _a.iconPosition, _d = _a.padding, padding = _d === void 0 ? '' : _d, className = _a.className, children = _a.children, onClick = _a.onClick;
    return (_jsxs("div", __assign({ onClick: onClick, className: classNames(styles.getChipStyles(backgroundColour, borderColour, padding), className), style: { height: 'fit-content' } }, { children: [iconPosition === 'start' &&
                icon &&
                renderIcon(icon, "w-5 h-5 text-".concat(textColour, " mr-2")), _jsx(Typography, { type: textType, weight: textWeight, color: textColour, text: text, lineHeight: 4, className: "text-center" }), children, iconPosition === 'end' &&
                icon &&
                renderIcon(icon, "w-5 h-5 text-".concat(textColour, " ml-2"))] })));
};
export default StatusChip;
//# sourceMappingURL=status-chip.js.map